export default __webpack_public_path__ + "_/images/seed-1d71c0a9b207511ffd1a2b875c02819bf7a84184a8fb78064d4a85fa2c7dbef3.svg";